import type { AxiosResponse } from "axios";

export default function (reponse: AxiosResponse<any>, defaultFileName?: string) {
  const contentDisposition = reponse.headers["content-disposition"];
  let fileName = defaultFileName;

  if (contentDisposition) {
    const parts = contentDisposition.split(";").map((part: string) => part.trim());

    const fileNameStarPart = parts.find((part: string) => part.startsWith("filename*="));
    if (fileNameStarPart) {
      const regex = /filename\*=(?:UTF-8'')?(.+)/i;
      const match = regex.exec(fileNameStarPart);
      if (match) {
        fileName = decodeURIComponent(match[1]);
      }
    } else {
      const fileNamePart = parts.find((part: string) => part.startsWith("filename="));
      if (fileNamePart) {
        fileName = fileNamePart.split("=")[1].replace(/^["']|["']$/g, "");
      }
    }
  }

  return fileName;
}
